/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/set-state-in-effect */
import { useState, useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSnapshot } from "valtio";
import { editorState } from "../../utils/editor";
import MessageCard from "./message-card";

interface Message {
  id: number;
  text: string;
  issueType: string;
  timestamp: string;
}

interface Chat {
  id: string;
  issueType: string;
  messages: Message[];
  createdAt: string;
  lastMessageTime: string;
  status: string;
}

const Messages = () => {
  const navigate = useNavigate();
  const { XAccountHash } = useSnapshot(editorState);
  const [chats, setChats] = useState<Chat[]>([]);

  useEffect(() => {
    // Load chats from localStorage
    const storageKey = `user-${XAccountHash}-chats`;
    const storedChats = JSON.parse(localStorage.getItem(storageKey) || "[]");
    // Sort by last message time (most recent first)
    const sortedChats = storedChats.sort(
      (a: Chat, b: Chat) =>
        new Date(b.lastMessageTime).getTime() -
        new Date(a.lastMessageTime).getTime()
    );
    setChats(sortedChats);
  }, []);

  const getTimeAgo = (dateString: string) => {
    const now = new Date();
    const messageDate = new Date(dateString);
    const diffInMs = now.getTime() - messageDate.getTime();
    const diffInMins = Math.floor(diffInMs / 60000);
    const diffInHours = Math.floor(diffInMs / 3600000);
    const diffInDays = Math.floor(diffInMs / 86400000);

    if (diffInMins < 1) return "Just now";
    if (diffInMins < 60)
      return `${diffInMins} min${diffInMins > 1 ? "s" : ""} ago`;
    if (diffInHours < 24)
      return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    if (diffInDays < 7)
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    return messageDate.toLocaleDateString();
  };

  return (
    <div className="flex flex-col gap-3 h-screen w-full px-5">
      <div className="flex items-center w-full py-5 relative">
        <button
          onClick={() => navigate("/support")}
          className="absolute left-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <ChevronLeft size={24} className="text-gray-900" />
        </button>
        <h1 className="text-[32px] font-[400] w-full text-center optima">
          Messages
        </h1>
      </div>

      {chats.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <p className="text-gray-400 text-lg glacial">No messages yet</p>
          <p className="text-gray-400 text-sm glacial mt-2">
            Your conversations will appear here
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {chats.map((chat) => (
            <MessageCard
              key={chat.id}
              issueType={chat.issueType}
              lastMessage={chat.messages[chat.messages.length - 1]?.text || ""}
              timeAgo={getTimeAgo(chat.lastMessageTime)}
              onClick={() => navigate(`/send-a-message?chatId=${chat.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Messages;
